import { parseEffectDataJSON } from "../common/helpers.tsx";
import { LayerData } from "../layers/layerData.model.tsx";
import { BaseSerializer } from "./baseSerializer.ts";
import { LayerSerializer } from "./layerSerializer.ts";

export class CompositionSerializer extends BaseSerializer {
  public deserialize(data: any): any {
    const gp = new LayerData(data);
    if (gp.children.length < 1) return gp;
    gp.children = gp.children
      .map((child) => {
        const newChild = new LayerSerializer().deserialize(child);
        newChild.effects = newChild.effects.map((effect) => {
          return parseEffectDataJSON(effect);
        });
        return newChild;
      })
      .sort((a, b) => a.order - b.order);
    return gp;
  }
}
